<script lang="ts" setup>
interface ComponentProps {
  invoiceData: any;
}

const {invoiceData = {}} = defineProps<ComponentProps>();


const {t} = useI18n()

const destinationText = computed(()=> {
  if (!invoiceData.list){
    return ''
  }
  if (invoiceData.list.length === 1) {
    return t('pdf.invoice.carName', {
      carName: invoiceData.list[0].carDescription,
      vin: invoiceData.list[0].vinCode
    })
  } else {
    return "aggregated: " + invoiceData.list.map((item) => {
      if (item.subtotal) {
        return false
      }
      return item.vinCode.slice(-5)
    }).filter(item => item).join(';')
  }
})

</script>

<template>
  <!--  <Teleport to="#teleports">-->
  <div class="car-invoice-v2">
    <div class="gradient-line">
      <img src="~/assets/img/invoice-gradient.png">
    </div>
    <div
      class="car-invoice-v2__container"
    >
      <PdfPartsHeaderCompany5 />

      <div class="car-invoice-v2__short-info">
        <div class="car-invoice-v2__short-info-left">
          <span class="text">{{ t('pdf.invoice.companyLabel') }}</span>
          <span class="text">{{ t('pdf.invoice.company5.company') }}</span>
        </div>
        <div class="car-invoice-v2__short-info-right">
          <span class="text">
            {{ t('pdf.invoice.date') }}
            <FormatDate
              format="LLLL dd, yyyy"
              :date="invoiceData.date"
            />
          </span>
          <span class="text">{{ t('pdf.invoice.invoiceId', {invoiceId: invoiceData.invoiceId}) }}</span>
        </div>
      </div>

      <div class="car-invoice-v2__customer">
        <span class="name">{{ t('pdf.invoice.customerName', {customerName: invoiceData.fio}) }}</span>
        <span class="value">{{ t('pdf.invoice.customerId', {customerId: invoiceData.inn}) }}</span>
      </div>

      <PdfPaymentDetailsTable :invoice-data="invoiceData" />

      <div class="car-invoice-v2__instruction">
        <div class="item">
          <p class="title">
            {{ t('pdf.invoice.wireInstruction') }}
          </p>
        </div>
      </div>

      <PdfPartsSignature
        :total-balance="invoiceData.totalBalance"
        :wire-instructions="invoiceData.wireInstructions"
        signature-path="/img/signature/autotaqia.png"
      />

      <div class="car-invoice-v2__purpose">
        <span class="title">{{ t('pdf.invoice.company5.destination') }}</span>
        <span
          class="text"
          v-html="destinationText"
        />
      </div>
      <PdfPartsFooterCompany5 />
    </div>
  </div>
<!--  </Teleport>-->
</template>

<style lang="scss" scoped>
@media print {
  @page {
    margin: -1px;
    margin-top: -3px;
  }
}

.car-invoice-v2 {
  print-color-adjust: exact;

  position: relative;
  display: block;
  padding-top: 20px;
  font-size: 10px;

  .gradient-line {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 20px;

    img {
      width: 100%;
      height: 100%;
    }
  }

  &__container {
    padding: 0 30px 15px;
    width: 100%;
  }

  &__short-info {
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding: 12px 0;
    border-bottom: 1px solid #000;

    &-left,
    &-right {
      display: flex;
      flex-direction: column;

      .text {
        font-weight: 700;
        display: block;
        margin-bottom: 5px;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }

    &-right {
      text-align: right;
    }
  }

  &__customer {
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding: 12px 0;
    font-weight: 700;
  }
}

.car-invoice-v2__purpose {
  display: flex;
  flex-direction: column;
  font-weight: 600;
  margin: 15px 0;

  .title {
    color: #DA3A32;
  }

  .text {
    text-decoration: underline;
    font-size: 11px;
  }
}

.car-invoice-v2__instruction {
  padding: 12px 0;
  border-bottom: 1px solid #000;
  border-top: 1px solid #000;

  .item {
    font-size: 11px;
    max-width: 420px;

    .title {
      font-weight: 600;
    }
  }
}

</style>
